import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconTrash = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.5 5C15.0648 5 15.9342 5.72123 15.9964 6.86604L16 7H18V9H17V16C17 17.8183 16.1365 18.9194 14.6659 18.9958L14.5 19H9.5C7.98477 19 7.06715 17.9638 7.00354 16.1991L7 16V9H6V7H8C8 5.82305 8.81139 5.05822 10.3225 5.00318L10.5 5H13.5ZM9 9V16C9 17 10 17 10 17H14C14.5 17 15 17 15 16V9H9ZM13.5 6C14 6 14 6.48148 14 7H10C10 7 10.0032 6.90181 10.0028 6.85553C10 6.5 10 6 10.5 6H13.5ZM14 11V15H13V11H14ZM11 11H10V15H11V11Z"
        />
      </svg>
    );
  }
);
